var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-view"},[_c('div',{staticClass:"home-view__title"}),_c('div',{staticClass:"home-view__content"},[_c('proximos-partidos')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }